/**
 * Custom error class for authentication-related errors
 * Used by authService to provide consistent error format: { message, status }
 */
export class AuthError extends Error {
  constructor(message, status = 401) {
    super(message);
    this.name = 'AuthError';
    this.status = status;
  }
}

export default AuthError;
